import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RouteComponentProps } from "@reach/router";
import styled from 'styled-components';
import moment from 'moment-timezone';
import DatePicker from 'react-datepicker'

const StyledFilters = styled.div`
  width: 100%;
  // height: 40px;
  box-sizing: border-box;
  margin: 20px 0 10px 0;
  display: flex;
  justify-content: center;
`;

const Item = styled.div`
  padding: 0 5px;
`;

const Label = styled.p`
  display: inline;
  color: #233567;
  padding: 10px;
`;

const StyledSelect = styled.select`
  display: inline;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  height: 30px;
  padding: 0px 10px;
  font-size: 16px;
  line-height: 1.75;
  color: #233567;
  background: #ffffff;
  border: 1px solid #233567;
  border-radius: 35px;
  text-align: center;
  margin: 0 auto;
`;

const StyledDatePickerInput = styled.input`
  width: 130px;
  height: 30px;
  padding: 0px 10px;
  font-size: 16px;
  line-height: 1.75;
  color: #233567;
  background: #ffffff;
  border: 1px solid #233567;
  border-radius: 35px;
  text-align: center;
  cursor: pointer;
`;

const ExampleCustomInput = ({ value, onClick }: { value?: any; onClick?: any; }) => (
  <StyledDatePickerInput className="example-custom-input" onClick={onClick} value={value}/>
);

const Select = ({ value, options, onChange }: { value: string; options: string[]; onChange: any }) => {
  return (
    <StyledSelect value={value} onChange={onChange}>
      {options.map(option => (
        <option key={value} value={option}>{option}</option>
      ))}
    </StyledSelect>
  )
}

export const Filters = ({ position }: { position?: any; }) => {
  
  const [filters, setFilters] = useState({ type: 'CSV', startDate:  (new Date(Date.now() - 604800000)), endDate: (new Date()) })
  
  return (
    <StyledFilters>
      <Item>
        <Select value={filters.type} options={['CSV', 'Reports', 'Audio']} onChange={select_event => {setFilters({ ...filters, type: select_event.target.value }); console.log(filters)}}/>
      </Item>
      <Item>
        <Label>Start</Label>
        <DatePicker selected={filters.startDate} onChange={date => setFilters({ ...filters, startDate: date })} dateFormat="yyyy/MM/dd" customInput={<ExampleCustomInput />}/>
      </Item>
      <Item>
        <Label>End</Label>
        <DatePicker selected={filters.endDate} onChange={date => setFilters({ ...filters, endDate: date })} dateFormat="yyyy/MM/dd" customInput={<ExampleCustomInput />}/>
      </Item>
    </StyledFilters>
  )
}